exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700);", ""]);

// module
exports.push([module.id, ".v-application .theme--dark.white .theme--dark.v-btn.v-btn--icon{color:#455a64!important}.v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined),.v-sheet.v-card:not(.v-sheet--outlined){box-shadow:0 0 1px 0 rgba(0,0,0,.1)}.v-btn--icon.v-size--default .v-icon{width:20px;font-size:20px}.hidelogo{display:none}.searchinput{position:absolute;width:100%;margin:0;left:0;z-index:10;padding:0 15px}.descpart{max-width:220px}", ""]);

// exports
